import React from "react";
import { Moon, Sun } from "lucide-react";
import { useAppTheme } from "../context/ThemeContext";
import { cn } from "@/lib/utils";

/**
 * Pulsante sole/luna per passare fra tema chiaro e scuro.
 * `variant="admin"` usa i token del pannello admin; `variant="plain"` eredita il colore dal contenitore.
 */
export default function ThemeToggle({ className = "", variant = "plain", testId = "theme-toggle" }) {
  const { effectiveTheme, themable, toggleTheme } = useAppTheme();
  if (!themable) return null;
  const isDark = effectiveTheme === "dark";
  const label = isDark ? "Passa al tema chiaro" : "Passa al tema scuro";
  const base =
    "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0";
  const look =
    variant === "admin"
      ? "text-admin-muted hover:bg-admin-highlight hover:text-admin-text focus-visible:ring-admin-accent"
      : "text-slate-500 hover:bg-slate-100 hover:text-slate-700 focus-visible:ring-slate-400";
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      aria-pressed={isDark}
      title={label}
      data-testid={testId}
      className={cn(base, look, className)}
    >
      {isDark ? <Sun className="h-[18px] w-[18px]" aria-hidden="true" /> : <Moon className="h-[18px] w-[18px]" aria-hidden="true" />}
    </button>
  );
}
